<template>
  <CFooter :fixed="false">
    <div>
      <a :href="APP_URL" target="_blank">2Link</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a :href="APP_URL" target="_blank">2Link</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      APP_URL: APP_URL
    }
  }
}
</script>
